import routerOptions0 from "/shared/app/build/enabled/production/ssg/www/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.0_@types+node@20.12.0_db0@0.2.1_encoding@0.1.13_eslint@9.10.0_l7tqcej7uc3wufqsjl53wba5ti/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}